import { Component } from '@angular/core';

import { SkySectionedFormService } from '../../core';


export class SkyDemoInformationFormComponent {
  private _nameRequired: boolean;
  private _name: string = '';
  private _id: string = '5324901';

  public get nameRequired() {
    return this._nameRequired;
  }

  public set nameRequired(value: boolean) {
    this._nameRequired = value;
    this.sectionedFormService.requiredFieldChanged(value);
  }

  public get name() {
    return this._name;
  }

  public set name(value: string) {
    this._name = value;

    if (this._nameRequired) {
      this.sectionedFormService.requiredFieldChanged(!this._name);
    }
  }

  public get id() {
    return this._id;
  }

  public set id(value: string) {
    this._id = value;

    const valid = this.idValid(this._id);
    this.sectionedFormService.invalidFieldChanged(!valid);
  }

  constructor(
    private sectionedFormService: SkySectionedFormService
  ) { }

  private idValid(value: string) {
    if (value) {
      let regExp = new RegExp('^[0-9]+$');
      return regExp.test(value);
    } else {
      return true;
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-demo-information-form',
  template: `<div style="display: flex;">
  <div style="margin-right: 10px; flex: 1;">
    <label 
      for="inputName" 
      class="sky-control-label"
      [ngClass]="{'sky-control-label-required': nameRequired}"
    >
      Name
    </label>
    <input 
      class="sky-form-control"
      [(ngModel)]="name"
      id="inputName" 
      type="text"
      [required]="nameRequired"
    />
  </div>
  <div style="margin-right: 10px; flex: 1;">
    <label 
      for="inputId" 
      class="sky-control-label"
    >
      ID
    </label>
    <input 
      class="sky-form-control"
      [(ngModel)]="id"
      id="inputId" 
      type="text"
    />
  </div>
</div>

<div style="margin-top: 10px;">
  <sky-checkbox [(ngModel)]="nameRequired">
    <sky-checkbox-label>
      Make 'Name' required
    </sky-checkbox-label>
  </sky-checkbox>
</div>
  
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkySectionedFormService, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
